/** Кольцо прогресса (A0): доля сданных гейтов, не процент просмотра. */
export function ProgressRing({
  done,
  total,
  size = 56,
  stroke = 5,
  color = "var(--acc)",
  caption,
}: {
  done: number;
  total: number;
  size?: number;
  stroke?: number;
  color?: string;
  caption?: string;
}) {
  const pct = total > 0 ? Math.min(1, done / total) : 0;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const fs = size >= 72 ? 14 : 12;
  return (
    <div className="flex flex-col items-center gap-2">
      <div className="relative" style={{ width: size, height: size }} role="img" aria-label={`${done} из ${total}`}>
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="block -rotate-90">
          <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="var(--card2)" strokeWidth={stroke} />
          <circle
            cx={size / 2}
            cy={size / 2}
            r={r}
            fill="none"
            stroke={color}
            strokeWidth={stroke}
            strokeLinecap="round"
            strokeDasharray={`${c * pct} ${c}`}
          />
        </svg>
        <span className="absolute inset-0 grid place-items-center font-mono font-semibold text-ink" style={{ fontSize: fs }}>
          {done}/{total}
        </span>
      </div>
      {caption && <span className="font-mono text-[10.5px] text-mut">{caption}</span>}
    </div>
  );
}

export function ProgressBar({ done, total, label }: { done: number; total: number; label?: string }) {
  const pct = total > 0 ? Math.round((100 * done) / total) : 0;
  return (
    <div>
      {label && (
        <div className="mb-1.5 flex justify-between font-mono text-[11px] text-mut">
          <span>{label}</span>
          <span>
            {done} / {total}
          </span>
        </div>
      )}
      <div className="h-1.5 overflow-hidden rounded-[3px] bg-card2" role="progressbar" aria-valuenow={done} aria-valuemax={total}>
        <div className="h-full bg-acc" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
